import React, { useMemo, useRef, useState } from 'react';
import { useStyletron } from 'baseui';
import { useTimelinePointerEvents } from './hooks/use-timeline-pointer-events';
import { TimelineGesturesContext } from './context';
type PropsT = {
  children: React.ReactNode;
};
export const TimelineGestures = ({
  children
}: PropsT) => {
  const [css] = useStyletron();
  const [stage] = useState(() => new EventTarget());
  const containerRef = useRef<HTMLDivElement>(null);
  const pointerHandlers = useTimelinePointerEvents(stage, containerRef);
  const contextValue = useMemo(() => ({
    stage
  }), [stage]);
  return <TimelineGesturesContext.Provider value={contextValue}>
      <div ref={containerRef} className={css({
      position: 'relative',
      width: '100%',
      height: '100%'
    })} data-testid="timeline-gestures" {...pointerHandlers}>
        {children}
      </div>
    </TimelineGesturesContext.Provider>;
};